import {Color as CesiumColor} from "cesium";

export const Color = {
    red: CesiumColor.fromBytes(248, 1, 131, 200),
    green: CesiumColor.fromBytes(48, 200, 32, 200),
    blue: CesiumColor.fromBytes(41, 23, 200, 200),
}
